export default "__VITE_ASSET__qBfvB1l3__ 584w";